import '@shopify/polaris/build/esm/styles.css';

import React from 'react';
import PropTypes from 'prop-types';

import {AppProvider, Page, LegacyCard, Button, Tooltip, Collapsible, Text} from '@shopify/polaris';

import {ChevronLeftIcon} from '@shopify/polaris-icons';

import './PublicPlansPage.css';
import * as styles from './pages/PlanStyles.module.scss';

export default class PublicPlans extends React.Component {

  static propTypes = {
    translations: PropTypes.object,
    appHost: PropTypes.string,
    storeAppUrl: PropTypes.string,
    plans: PropTypes.object,
  };

  renderPlan = (plan) => {
    const {loadingPlan} = false;
    const content = this.props.translations.plans[plan.slug];
    const planClassNames = `${styles.currentPlanDecorator}`;

    return (
      <div key={plan.slug} className={`${planClassNames}`}>
        <LegacyCard title={this.renderPricing(plan.price)} sectioned>
          <div className={styles.flexCardWrapper}>
            <Button
              loading={loadingPlan === plan.slug}
              onClick={() => { this.subscribeToPlan(plan.slug); }}
              variant="primary"
              tone="success"
            >
              {plan.choose_plan_button_translation}
            </Button>
            <Text variant="heading2xl" as="p">{content.name}</Text>
            <p>{content.description}</p>
            <br />

            <Button onClick={() => { this.togglePlanDetails(plan.slug); }} variant="plain">
              { this.props.translations.view_more_button[this.viewMoreButtonStatus(plan.slug)] }
            </Button>
            <br />
            { this.renderCollapsibleArea(content.features, plan.slug) }
          </div>
        </LegacyCard>
      </div>
    );
  };

  viewMoreButtonStatus = (slug) => {
    const stateName = this.stateNameForPlan(slug);
    return this.state[stateName] ? 'hide' : 'show';
  };

  togglePlanDetails = (slug) => {
    this.setState((state) => {
      const stateName = this.stateNameForPlan(slug);
      const open = !state[stateName];
      return {[stateName]: open};
    });
  };

  stateNameForPlan = (slug) => {
    return `is_${slug}_details_open`;
  };

  subscribeToPlan = (slug) => {
    document.cookie = `subscribe_to_plan=${slug};path=/`;
    window.location.href = `${this.props.appHost}/login`;
  };

  goBack = () => {
    window.location.href = this.props.storeAppUrl;
  };

  renderCollapsibleArea = (features, slug) => {
    return (
      <Collapsible open={this.state[this.stateNameForPlan(slug)]} id="basic-collapsible">
        <div className={styles.cardList}>
          {features.map((feature) => { return this.renderFeature(feature); })}
        </div>
      </Collapsible>
    );
  };

  renderPricing = (price) => {
    return (
      <p className={styles.pricingTag}>
        <span className={styles.pricingTagSmall}>$</span>
        {price}
        <span className={styles.pricingTagSmall}>/month</span>
      </p>
    );
  };

  renderSvg = () => {
    return (
      <span className={styles.infoIcon}>
        <svg aria-hidden="true" focusable="false">
          <svg id="next-info" width="100%" height="100%"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M13.5 7h-2c-.8 0-1.5.7-1.5 1.5v14c0 .8.7 1.5 1.5 1.5h2c.8 0 1.5-.7 1.5-1.5v-14c0-.8-.7-1.5-1.5-1.5z" /><circle cx="12.5" cy="2.5" r="2.5" /></g></svg></svg>
        </svg>
      </span>
    );
  };

  renderFeature = (feature) => {
    return (
      <React.Fragment key={feature.title}>
        <Text variant="headingMd" as="h2">{feature.title}</Text>
        <p>{feature.description}
          {feature.help_text && (
            <Tooltip content={feature.help_text}>
              {this.renderSvg()}
            </Tooltip>
          )}
        </p>
      </React.Fragment>
    );
  };

  state = {};

  render() {
    const {plans} = this.props;

    return (
      <AppProvider i18n={{}}>
        <main className={`${styles.mainWrapper}`}>
          <Page>
            <Button onClick={this.goBack} icon={ChevronLeftIcon} variant="plain">
              <span className={styles.backButton}>
                {this.props.translations.back_button}
              </span>
            </Button>
            <Text variant="heading2xl" as="p">{this.props.translations.choose_plan_title}</Text>
            <hr style={{border: 0, borderBottom: '1px solid #dfe3e8', marginBottom: '20px'}} />

            <div className={styles.flexCardsRow}>
              { Object.keys(plans).map((key) => { return this.renderPlan({...plans[key], slug: key}); }) }
            </div>
          </Page>
        </main>
      </AppProvider>
    );
  }
}
